module.exports = __webpack_public_path__ + "static/nek-4da9b449ed800632d8d0e7a698c1d736.jpg";